<dx-popup class="toolbar-visibility-popup"
          [wrapperAttr]="{ class: 'toolbar-visibility-popup' }"
          [width]="540"
          [height]="500"
          [showTitle]="true"
          title="Toolbar Elements"
          [visible]="this.visible"
          [closeOnOutsideClick]="true"
          [dragEnabled]="true"
          [resizeEnabled]="true"
          [showCloseButton]="true"
          (onHiding)="this.onHiding()">

    <div *dxTemplate="let data of 'content'" class="wrapper">

        <div class="columns">
            <div class="column" *ngFor="let col of this.columns">
                <div class="column-title">{{ col.title }}</div>
                <dx-scroll-view class="list" direction="vertical">
                    <div class="row" *ngFor="let row of col.rows">
                        <dx-check-box [(value)]="row.visible"
                                      [text]="row.label">
                        </dx-check-box>
                    </div>
                </dx-scroll-view>
            </div>
        </div>

        <div class="controls">
            <dx-button text="Apply"
                       type="default"
                       width="110"
                       (onClick)="this.onApplyClick()">
            </dx-button>
            <dx-button text="Cancel"
                       width="110"
                       (onClick)="this.onCancelClick()">
            </dx-button>
        </div>

    </div>

</dx-popup>
